import { Layout, LayoutContent, VStack } from '@astryxdesign/core/Layout';
import { Heading, Text } from '@astryxdesign/core/Text';
import { Theme } from '@astryxdesign/core/theme';
import { neutralAppTheme } from '@/theme/studioTheme';

/** Neutral root page. Studios live under /s/{slug}/; nothing studio-specific here. */
export function LandingPage() {
  return (
    <Theme theme={neutralAppTheme} mode="dark">
      <Layout
        height="fill"
        contentWidth={640}
        content={
          <LayoutContent padding={6}>
            <VStack gap={3}>
              <Heading level={1}>Онлайн-запись в автосервис</Heading>
              <Text color="secondary">Откройте ссылку конкретной студии, чтобы посмотреть услуги и записаться.</Text>
            </VStack>
          </LayoutContent>
        }
      />
    </Theme>
  );
}
